import React from 'react';
import {inject, observer} from 'mobx-react';
import localeText from '@locale';
import MobileNavBack from '~/components/MobileNavBack';
import {Mobile} from '~/components/Responsive';
import './index.less';
import './mobile.less';

@inject((stores, props) => {
  const {portalStore, sessionStore} = stores;
  return {
    ...props,
    portalStore,
    sessionStore
  };
})
@observer
class AppSwitcher extends React.Component {
  componentDidMount() {
    const {workingMenu} = this.props.portalStore;
    window.$sdk$.setPageTitle(workingMenu?.name || 'App Portal');
  }

  generateAppPanel = () => {
    const {
      portalStore: {categoryWithApps, workingApp = {}, isNewNavigation, showMenu, viewMode},
      uiStore,
      onClose
    } = this.props;

    const categoryWith = 212;

    let autoLeft;
    if (isNewNavigation) {
      if (!showMenu || viewMode === 1) {
        autoLeft = '51px';
      } else {
        autoLeft = '241px';
      }
    } else {
      autoLeft = '200px';
    }

    let panelWith = 4 * (categoryWith + 8) + 30;
    const currentAppId = workingApp && workingApp.id;

    if (categoryWithApps.length === 0) {
      panelWith = 200;
    }

    if (categoryWithApps.length <= 4 && categoryWithApps.length !== 0) {
      panelWith = categoryWithApps.length * (categoryWith + 8) + 30;
    }

    const categories = categoryWithApps.map(category => (
      <div className='app-category' {...{[['key'][0]]: category.id}} style={{width: categoryWith}}>
        <div className='category-name' title={category.name}>{category.name}</div>
        <div className='app-list'>
          {category.apps.map(app => (
            <div
              className={app.id === currentAppId ? 'current app-item' : 'app-item'}
              onClick={() => {
                window.$sdk$.switchPage({
                  appId: app.id
                });
              }}
              {...{[['key'][0]]: app.id}}
            >
              <span className='name' title={app.name}>
                {app.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    ));

    const closeAppSwitcher = (e) => {
      uiStore.toggleAppSwitcher();
      e.stopPropagation();
    };

    return (
      <div className={uiStore.showAppSwitcher ? 'app-panel open' : 'app-panel'} style={{width: panelWith, left: autoLeft}}>
        <Mobile>
          <MobileNavBack
            title={localeText('PORTAL.BTN_CHANGE_APP')}
            onBack={(e) => {
              closeAppSwitcher(e);
            }}
            onClose={(e) => {
              closeAppSwitcher(e);
              onClose();
            }}
          />
        </Mobile>
        <div className='app-panel-warp' />
        {categoryWithApps.length ? (
          <div className='app-panel-content'>{categories}</div>
        ) : (
          <div className='no-app'>{localeText('PORTAL.NO_APP')}</div>
        )}
      </div>
    );
  };

  render() {
    return <div className='app-switcher sub'>{this.generateAppPanel()}</div>;
  }
}

export default AppSwitcher;
